import gql from "graphql-tag";

export const createAnnouncement = gql`
  mutation CreateAnnouncement($data: AnnouncementCreateInput!) {
    createAnnouncement(data: $data) {
      id
    }
  }
`;
